import React from "react";
import { Button } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import { usePermissions } from "./usePermissions";
import { DeclarationStatusDto } from "../types/Api";
/**
 * Action-menu entry for declaring (or correcting) the last used number of a publisher prefix.
 * Shared by the prefix list detail pane and the standalone prefix detail page so that the
 * visibility rule and the route stay defined in one place.
 */
export var useDeclareLastUsedNumberAction = function (prefix) {
    var history = useHistory();
    var _a = usePermissions(), canDeclareLastUsedNumber = _a.canDeclareLastUsedNumber, isAgencyWorker = _a.isAgencyWorker;
    var isPending = (prefix === null || prefix === void 0 ? void 0 : prefix.declarationStatus) === DeclarationStatusDto.PENDING;
    var isCorrection = isAgencyWorker &&
        (prefix === null || prefix === void 0 ? void 0 : prefix.declarationStatus) === DeclarationStatusDto.DECLARED;
    var canShowDeclareAction = (canDeclareLastUsedNumber && isPending) || isCorrection;
    var declareAction = canShowDeclareAction ? (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
            return history.push("/bragency/publisher-prefixes/declare-last-used?id=".concat(prefix === null || prefix === void 0 ? void 0 : prefix.id));
        }, fullWidth: true },
        React.createElement(FormattedMessage, { id: isCorrection
                ? "ui-br-agency.publisher-prefix.declare.action.correct"
                : "ui-br-agency.publisher-prefix.declare.action" }))) : null;
    return { canShowDeclareAction: canShowDeclareAction, declareAction: declareAction };
};
